import { memo } from 'react';
import { Flex, Heading, VStack } from '@chakra-ui/react';

import { CopyButton } from '../../../components/ButtonComponents/CopyButton';
import MarkdownDisplay from '../../../components/MarkdownDisplay';
import { ANALYTICS_EVENT_NAME } from '../../../utils/constants/analytics-constants';
import i18n from '../../../utils/i18n';

import { QuestionInsightProps } from './QuestionInsightsExpandable';

export const QuestionInsightsStatic = memo(
  ({ question, questionAnalysisContent = '' }: QuestionInsightProps) => {
    return (
      <VStack
        align="start"
        h={'100%'}
        pt={4}
        id="question-insights-static"
        data-testid="question-insights-static"
      >
        <Flex
          w={'100%'}
          direction="row"
          align={'flex-start'}
          justify={'space-between'}
        >
          <Heading visibility={{ base: 'hidden', md: 'visible' }}>
            {i18n.t('engagementDetails.questionCards.analysisHeading')}
          </Heading>
          <CopyButton
            contentToCopy={questionAnalysisContent}
            analyticsEventName={
              ANALYTICS_EVENT_NAME.ENGAGEMENT_DETAILS.ANALYSIS_COPY
            }
            analyticstoTrack={{
              engagementId: question.engagementId,
              questionId: question.id,
              position: question.position,
            }}
          />
        </Flex>
        <MarkdownDisplay source={questionAnalysisContent} />
      </VStack>
    );
  }
);
QuestionInsightsStatic.displayName = 'InsightsOnly';
